module.exports = __webpack_public_path__ + "front/img/yqh01.04e60d55.png";